import { Injectable } from '@angular/core';

import { AuthService } from 'app/providers/bridge-api/auth.service';
import {
  AccountMetadata,
  StorageAccountService,
} from 'app/providers/storage-api/blender-account.service';
import { Field } from 'app/providers/storage-api/field.service';
import { WidgetDataSource } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsService {
  constructor(
    private authService: AuthService,
    private accountService: StorageAccountService
  ) {}

  async getMetadataSubTypesAsync(dataSource: WidgetDataSource): Promise<string[]> {
    const metadata = await this.accountService.groupFieldsSub.latest();
    return this.getMetadataSubTypes(dataSource, metadata);
  }

  getMetadataSubTypes(dataSource: WidgetDataSource, accountMetadata: AccountMetadata): string[] {
    const metadataSubTypes: string[] = [];

    //If Field is alias, and contains datasource custom fields, use it instead of original fields
    dataSourceFields: for (const fieldName of dataSource?.customFields) {
      for (const field of accountMetadata.metadata) {
        if (
          field.fieldName === fieldName &&
          field.metadata?.redacted === true &&
          this.authService.isAlwaysRedact
        ) {
          continue dataSourceFields;
        }

        if (field.aliasedFields?.includes(fieldName)) {
          metadataSubTypes.push(field.fieldName);

          continue dataSourceFields;
        }
      }

      metadataSubTypes.push(fieldName);
    }

    if (dataSource.calculatedFields) {
      metadataSubTypes.push(...dataSource.calculatedFields);
    }

    //Remove duplicates
    return [...new Set(metadataSubTypes)];
  }

  async getUnAliasedWeightFieldsAsync(dataSource: WidgetDataSource): Promise<any[]> {
    const metadata = await this.accountService.groupFieldsSub.latest();
    return this.getUnAliasedWeightFields(dataSource, metadata);
  }

  getUnAliasedWeightFields(dataSource: WidgetDataSource, accountMetadata: AccountMetadata): any[] {
    if (!accountMetadata) {
      return [];
    }
    return [...accountMetadata.metadata]
      .filter((f) => f.metadata?.weight && dataSource.unAliasedCustomFields?.includes(f.fieldName))
      .map((f) => ({
        ...f,
        displayName: f.description,
      }))
      .sort((f1, f2) =>
        f1.displayName.localeCompare(f2.displayName, undefined, { sensitivity: 'accent' })
      );
  }

  public anyFieldContainsValue(
    includedFields: string[],
    filteredFields: Field[],
    prop: 'redacted' | 'rating'
  ) {
    for (const includedField of includedFields) {
      const field = filteredFields.find((f) => f.fieldName === includedField);
      if (field.metadata[prop]) {
        return true;
      }
    }

    return false;
  }
}
